import {
  DashboardOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  SafetyOutlined,
  BankOutlined,
  ApartmentOutlined,
  AppstoreOutlined,
  TeamOutlined,
  ShopOutlined,
  OrderedListOutlined,
  SettingOutlined,
  FileDoneOutlined,
  ImportOutlined,
  ExperimentOutlined,
  InboxOutlined,
  SolutionOutlined,
  CarOutlined,
  AuditOutlined,
  NotificationOutlined,
  DollarOutlined,
  RollbackOutlined,
  CreditCardOutlined,
  ReconciliationOutlined,
  DownloadOutlined,
  SwapOutlined,
  FieldNumberOutlined,
  SendOutlined,
  BarChartOutlined,
  ClockCircleOutlined,
  AlertOutlined,
} from "@ant-design/icons";
import { Paths } from "Router/Paths";

/**
 * Menu list configuration for sidebar navigation
 * module_slug must match the backend module slugs
 * group determines the sidebar section label
 */
export const menuList = [
  // ── Overview ──
  {
    title: "Dashboard",
    path: Paths.dashboard,
    module_slug: "dashboard",
    icon: DashboardOutlined,
    group: "Overview",
  },
  {
    title: "Open Sales Orders",
    path: Paths.openSalesOrders,
    module_slug: "open-sales-orders",
    icon: ShoppingCartOutlined,
    group: "Overview",
  },

  // ── Inventory ──
  {
    title: "Purchase Requests",
    path: Paths.purchaseRequests,
    module_slug: "purchase-requests",
    icon: FileTextOutlined,
    group: "Inventory",
  },
  {
    title: "Purchase Orders",
    path: Paths.purchaseOrders,
    module_slug: "purchase-orders",
    icon: FileDoneOutlined,
    group: "Inventory",
  },
  {
    title: "Inter-Depot PO",
    path: Paths.interDepotPOs,
    module_slug: "purchase-orders",
    icon: SwapOutlined,
    group: "Inventory",
  },
  {
    title: "Goods Receipt",
    path: Paths.grnList,
    module_slug: "goods-receipt",
    icon: ImportOutlined,
    group: "Inventory",
  },
  {
    title: "STO Receipt",
    path: Paths.stoReceipt,
    module_slug: "sto-receipt",
    icon: ImportOutlined,
    group: "Inventory",
  },
  {
    title: "PO Receipt (Vendor)",
    path: Paths.poReceipt,
    module_slug: "goods-receipt",
    icon: ImportOutlined,
    group: "Inventory",
  },
  {
    title: "Batches",
    path: Paths.batches,
    module_slug: "batches",
    icon: ExperimentOutlined,
    group: "Inventory",
  },
  {
    title: "Stock on Hand",
    path: Paths.stockOnHand,
    module_slug: "stock-management",
    icon: InboxOutlined,
    group: "Inventory",
  },
  {
    title: "Stock Movements",
    path: Paths.stockMovements,
    module_slug: "stock-management",
    icon: InboxOutlined,
    group: "Inventory",
  },
  {
    title: "Stock Adjustment",
    path: Paths.stockAdjustment,
    module_slug: "stock-management",
    icon: InboxOutlined,
    group: "Inventory",
  },
  {
    title: "Opening Stock",
    path: Paths.openingStock,
    module_slug: "stock-management",
    icon: InboxOutlined,
    group: "Inventory",
  },
  {
    title: "Stock Register",
    path: Paths.stockRegister,
    module_slug: "stock-management",
    icon: ReconciliationOutlined,
    group: "Inventory",
  },
  {
    title: "Sales Register",
    path: Paths.salesRegister,
    module_slug: "stock-management",
    icon: FileTextOutlined,
    group: "Inventory",
  },
  {
    title: "Purchase Register",
    path: Paths.purchaseRegister,
    module_slug: "stock-management",
    icon: FileDoneOutlined,
    group: "Inventory",
  },
  {
    title: "Product-wise Sales Report",
    path: Paths.productWiseSalesReport,
    module_slug: "stock-management",
    icon: FileTextOutlined,
    group: "Inventory",
  },
  {
    title: "Stock Levels",
    path: Paths.stockLevels,
    module_slug: "stock-levels",
    icon: BarChartOutlined,
    group: "Inventory",
  },
  {
    title: "Stock Alerts",
    path: Paths.stockAlerts,
    module_slug: "stock-levels",
    icon: AlertOutlined,
    group: "Inventory",
  },

  // ── Sales ──
  {
    title: "Sales Orders",
    path: Paths.salesOrders,
    module_slug: "sales-orders",
    icon: ShoppingCartOutlined,
    group: "Sales",
  },
  {
    title: "Pick Lists",
    path: Paths.pickLists,
    module_slug: "picking",
    icon: SolutionOutlined,
    group: "Sales",
  },
  {
    title: "Dispatch",
    path: Paths.dispatches,
    module_slug: "dispatch",
    icon: CarOutlined,
    group: "Sales",
  },
  {
    title: "WMS Invoices",
    path: Paths.wmsInvoices,
    module_slug: "wms-invoices",
    icon: AuditOutlined,
    group: "Sales",
  },
  {
    title: "Invoices",
    path: Paths.invoices,
    module_slug: "invoices",
    icon: FileTextOutlined,
    group: "Sales",
  },

  // ── Warehouse ──
  {
    title: "Warehouse Zones",
    path: Paths.zones,
    module_slug: "warehouse-layout",
    icon: AppstoreOutlined,
    group: "Warehouse",
  },
  {
    title: "Warehouse Bins",
    path: Paths.bins,
    module_slug: "warehouse-layout",
    icon: AppstoreOutlined,
    group: "Warehouse",
  },
  {
    title: "Putaway Tasks",
    path: Paths.putawayTasks,
    module_slug: "putaway",
    icon: DownloadOutlined,
    group: "Warehouse",
  },
  {
    title: "Shelf Transfers",
    path: Paths.shelfTransfers,
    module_slug: "shelf-transfers",
    icon: SwapOutlined,
    group: "Warehouse",
  },
  {
    title: "Cycle Counts",
    path: Paths.cycleCounts,
    module_slug: "cycle-counts",
    icon: FieldNumberOutlined,
    group: "Warehouse",
  },
  {
    title: "Stock Transfers",
    path: Paths.stockTransfers,
    module_slug: "stock-transfers",
    icon: SendOutlined,
    group: "Warehouse",
  },
  {
    title: "Expiry Management",
    path: Paths.expiryDashboard,
    module_slug: "expiry-management",
    icon: ClockCircleOutlined,
    group: "Warehouse",
  },

  // ── Finance ──
  {
    title: "Credit Notes",
    path: Paths.creditNotes,
    module_slug: "credit-debit-notes",
    icon: ReconciliationOutlined,
    group: "Finance",
  },
  {
    title: "Debit Notes",
    path: Paths.debitNotes,
    module_slug: "credit-debit-notes",
    icon: ReconciliationOutlined,
    group: "Finance",
  },
  {
    title: "Payments",
    path: Paths.payments,
    module_slug: "payments",
    icon: DollarOutlined,
    group: "Finance",
  },
  {
    title: "Sales Returns",
    path: Paths.salesReturns,
    module_slug: "sales-returns",
    icon: RollbackOutlined,
    group: "Finance",
  },
  {
    title: "Depo Returns",
    path: Paths.depoReturns,
    module_slug: "sales-returns",
    icon: RollbackOutlined,
    group: "Finance",
  },
  {
    title: "Open Return SOs (POS)",
    path: Paths.posReturnSOsList,
    module_slug: "sales-returns",
    icon: RollbackOutlined,
    group: "Finance",
  },

  // ── Retail ──
  {
    title: "Sale Bill",
    path: Paths.saleBills,
    module_slug: "sale-bills",
    icon: ShoppingCartOutlined,
    group: "Retail",
  },
  {
    // Path A preview: literal-port POS Sale Bill GUI. Listed alongside
    // the existing Sale Bill so the two can be compared. Drop this
    // entry once the POS-mirror screen is verified and the original
    // create screen is replaced.
    title: "Sale Bill (POS-style)",
    path: Paths.createSaleBillPos,
    module_slug: "sale-bills",
    icon: ShoppingCartOutlined,
    group: "Retail",
  },
  {
    title: "Sale Return",
    path: Paths.saleReturns,
    module_slug: "sale-bills",
    icon: RollbackOutlined,
    group: "Retail",
  },

  // ── Administration (super_admin / admin only) ──
  {
    title: "Manage Companies",
    path: Paths.companies,
    module_slug: "manage-companies",
    icon: ApartmentOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "Manage Depots",
    path: Paths.depots,
    module_slug: "manage-depots",
    icon: BankOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "Manage Customers",
    path: Paths.customers,
    module_slug: "manage-customers",
    icon: TeamOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "Manage Suppliers",
    path: Paths.suppliers,
    module_slug: "manage-suppliers",
    icon: ShopOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "Number Series",
    path: Paths.numberSeries,
    module_slug: "number-series",
    icon: OrderedListOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "System Config",
    path: Paths.configurations,
    module_slug: "system-config",
    icon: SettingOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "Min Invoice Values",
    path: Paths.minInvoiceValues,
    module_slug: "system-config",
    icon: CreditCardOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "PR Depot Mapping",
    path: Paths.depotPRMappings,
    module_slug: "purchase-requests",
    icon: SwapOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "Store Brand Rules",
    path: Paths.storeBrandRestrictions,
    module_slug: "system-config",
    icon: SettingOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "Store Block List",
    path: Paths.storeBlockList,
    module_slug: "system-config",
    icon: AlertOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "SAP API Logs",
    path: Paths.sapLogs,
    module_slug: "system-config",
    icon: SettingOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    // Super admin only (backend /announcements enforces the same gate).
    title: "System Announcements",
    path: Paths.announcements,
    icon: NotificationOutlined,
    group: "Administration",
    adminOnly: true,
    superAdminOnly: true,
  },
  {
    title: "Manage Users",
    path: Paths.users,
    module_slug: "manage-users",
    icon: UserOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    title: "Manage Roles",
    path: Paths.roles,
    module_slug: "manage-roles",
    icon: SafetyOutlined,
    group: "Administration",
    adminOnly: true,
  },
  {
    // No module_slug — admin-only feature gated purely by adminOnly + the
    // role check (backend /audit-logs enforces the same role gate).
    title: "Audit Trail",
    path: Paths.auditLogs,
    icon: AuditOutlined,
    group: "Administration",
    adminOnly: true,
  },
];
